import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { upcoming_filter_Auction } from "../../../../../redux/action/auctionEvent";
import { handleDateSetUp, truncateText } from "../../../../../helpers/helpers";
import SellerAsideLoader from "../../../../commanPage/location/SellerAsideLoader";

function UpcommingAside() {
  const isDastop = useMediaQuery({ query: "(max-width: 1600px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 886px)" });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { upcomingfilterAuctionData } = useSelector(
    (pre) => pre?.asideFilterAuction
  );

  const { loading } = useSelector((pre) => pre.loading);
  const [numLiveData, setNumLiveData] = useState(3);

  //   handle the view live pages funtionality=============>>>>>>>>>>>>>>>
  const handleViewButton = () => {
    setNumLiveData(upcomingfilterAuctionData?.length);
  };

  useEffect(() => {
    dispatch(upcoming_filter_Auction());
  }, [dispatch]);

  return (
    <div
      className="p-1 border-radius-12"
      style={{ backgroundColor: "#edeef5" }}
    >
      <div className={`gap-1 ${isTablet && "grid-column-3"}`}>
        {loading && upcomingfilterAuctionData?.length === 0 ? (
          <SellerAsideLoader numLiveData={numLiveData} />
        ) : (
          upcomingfilterAuctionData
            ?.slice(0, numLiveData)
            .map((items, index) => (
              <div
                key={items?.auctionId}
                className="border-radius-12 white mb-1 pointer"
                style={{
                  border: "1px solid #6f2da8",
                  padding: "0.5rem 0.8rem",
                }}
                onClick={() => {
                  if (items?.auctionType === "reverseAuctionProduct") {
                    navigate(
                      `/product-reverse-auction/single-auction/${items?._id}`
                    );
                  } else if (
                    items?.auctionType === "reverseAuctionService"
                  ) {
                    navigate(
                      `/service-reverse-auction/single-auction/${items?._id}`
                    );
                  } else {
                    navigate(`/forward-auction/single-auction/${items?._id}`);
                  }
                }}
              >
                <div className={`valign-wrapper space-between flex-wrap`}>
                  <h6 className="cercle-purple-text font-14px">
                    Auction ID:{" "}
                    <span className="black-text font-13px">
                      {truncateText(items?.auctionId, 9)}
                    </span>
                  </h6>
                  <p
                    className={`small-text cercle-purple-text `}
                    style={{ display: isDastop && "none" }}
                  >
                    Date : {handleDateSetUp(items?.auctionSchedule?.startDate)}
                  </p>
                </div>
                <p
                  className="small-text NoOfline"
                  style={{ WebkitLineClamp: 2 }}
                >
                  {items?.description || "..."}
                </p>
                <p
                  className="flex small-text cercle-purple-text"
                  style={{
                    justifyContent: "end",
                    display: !isDastop && "none",
                  }}
                >
                  Date : {handleDateSetUp(items?.auctionSchedule?.startDate)}
                </p>
              </div>
            ))
        )}
      </div>
      {upcomingfilterAuctionData?.length !== 0 ? (
        <>
          {numLiveData === 3 && upcomingfilterAuctionData?.length > 3 ? (
            <div className="flex justify-center">
              <button
                className="bold font-14px white-text cercle-purple border-radius-12"
                style={{ padding: "7px 10px" }}
                onClick={handleViewButton}
              >
                View More
              </button>
            </div>
          ) : (
            <div className="flex justify-center">
              {upcomingfilterAuctionData?.length > 3 && (
                <button
                  className="bold font-14px white-text cercle-purple border-radius-12 mb-1"
                  style={{ padding: "7px 10px" }}
                  onClick={() => {
                    setNumLiveData(3);
                  }}
                >
                  View Less
                </button>
              )}
            </div>
          )}
        </>
      ) : (
        <div
          className="valign-wrapper justify-center column gap-1"
          style={{ height: "160px" }}
        >
          <img src="/images/noliveImg.png" alt="noliveimage" width={"120px"} />
          <p>No upcoming auctions available.</p>
        </div>
      )}
    </div>
  );
}

export default UpcommingAside;
